import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ReactComponent as IconCheck } from '../../../../icons/check.svg';
import ITrackShipmentResults from '../../../../interfaces/trackShipment/trackShipmentResults';
import IconArrowSteps from '../../../iconArrowSteps-v2';
import { getIconArrowSteps } from './helpers';
import * as StyledTrackShipmentIcons from './trackShipmentIcons.styles';

interface Props {
	internationalShipment: boolean;
	shipmentInfoSupplied?: ITrackShipmentResults;
}

const TrackShipmentIcons: FC<Props> = ({ internationalShipment, shipmentInfoSupplied }) => {
	const { t } = useTranslation('trackShipment');
	const { shipmentInfo }: { shipmentInfo: ITrackShipmentResults } = useSelector(
		({ trackShipmentReducer }) => trackShipmentReducer
	);
	const steps = getIconArrowSteps(
		t,
		internationalShipment,
		shipmentInfoSupplied ? shipmentInfoSupplied : shipmentInfo
	);

	const info = shipmentInfoSupplied ? shipmentInfoSupplied : shipmentInfo;
	const status = shipmentInfoSupplied ? shipmentInfoSupplied.status : shipmentInfo.status;

	if (info && status) {
		const stepNumber = info.adjustedStatus.adjustedStatusStep;

		// Marking the current step as primary
		if (steps[stepNumber]) {
			steps[stepNumber].primary = true;
		}

		// Marking as finished steps as secondary
		for (let i = 0; i < stepNumber + 1; ++i) {
			// If it's not the current one except if it's the last one
			if (i !== stepNumber || (i === stepNumber && i === steps.length - 1)) {
				// SECONDARY STEP = ALL STEPS THAT ARE DONE
				steps[i].secondary = true;
				// PRIMARY STEP = CURRENT STEP
				steps[i].primary = false;
				steps[i].iconComponent = IconCheck;
			}
		}
	}

	return (
		<StyledTrackShipmentIcons.Wrapper>
			<IconArrowSteps steps={steps} />
		</StyledTrackShipmentIcons.Wrapper>
	);
};

export default TrackShipmentIcons;
